import styled from 'styled-components';

export const Container = styled.li`
  display: flex;
  user-select: none;
  flex-direction: row; 
  flex: 1;
  width: auto;
  height: 2.2rem;
  padding: 0 0.4rem;
  border-radius: 6px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  gap: 0.3rem;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e9ecef;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  font-size: 0.8rem;
  font-weight: 500;
  color: #4a5057;

  &:active {
    transform: translateY(0);
  }

  p, span {
    font-size: 0.85rem;
    font-weight: 500;
    color: inherit;
    margin: 0;
  }

  &.selected {
    background-color: #1D86FF;
    border-color: #1D86FF;
    color: #ffffff;
    box-shadow: 0 2px 4px rgba(29, 134, 255, 0.2);
  }
`;